<template>
	<div ref="debtVisits" class="pt-3">
		<v-card flat color="transparent">
			<v-card-text class="pt-2">
				<v-row dense>
					<v-col cols="12" sm="4">
						<v-autocomplete
							v-model="regionIds"
							:items="regions"
							item-text="name"
							item-value="id"
							:label="$T('inputs.region')"
							multiple
							small-chips
							deletable-chips
							dense
							hide-details
							outlined
							@change="filter"
						/>
					</v-col>

					<v-col cols="12" sm="4">
						<v-autocomplete
							v-model="entityIds"
							:items="allEntities"
							item-text="name"
							item-value="id"
							:label="$T('DebtVisits.filter-customers')"
							multiple
							small-chips
							deletable-chips
							dense
							hide-details
							outlined
							@change="filter"
						/>
					</v-col>

					<v-col cols="12" sm="4">
						<v-autocomplete
							v-model="paymentStatuses"
							:items="statusItems"
							item-text="name"
							item-value="id"
							:label="$T('DebtVisits.filter-status')"
							multiple
							small-chips
							deletable-chips
							dense
							hide-details
							outlined
							@change="filter"
						/>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<v-container class="px-2">
			<v-row v-if="!loading && visits.length > 0" dense>
				<v-col sm="5" cols="12" v-for="visit in visits" :key="visit.id" class="mx-sm-auto">
					<debt-visit-card :visit="visit" class="mb-2" @on-payment-updated="onPaymentUpdated" />
				</v-col>
			</v-row>

			<div
				v-else-if="!loading && visits.length === 0"
				class="d-flex flex-column justify-center align-center"
				style="height: 45vh"
			>
				<v-icon x-large class="mb-3">mdi-cash-remove</v-icon>
				<span class="grey--text text--darken-2">{{ $T('DebtVisits.no-debt-visits-to-show') }}</span>
			</div>

			<loader v-if="loading"/>
		</v-container>
	</div>
</template>

<script>
import DebtVisitCard from '../components/DebtVisitCard.vue'
import Loader from '../components/Loader.vue'
import { mapState } from 'vuex'
import { debtPaymentStatus } from '@/helpers/enums'

export default {
	name: 'DebtVisits',

	components: {
		DebtVisitCard,
		Loader
	},

	data() {
		return {
			loading: true,

			entityIds: [],
			regionIds: [],
			paymentStatuses: [debtPaymentStatus.unpaid, debtPaymentStatus.partiallyPaid],

			perPage: 10,
			initPerpage: 10,
			nextPlusItemsforPerPage: 10
		}
	},

	computed: {
		...mapState({
			self: state => state.auth.self,
			visits: state => state.debtVisits.visits,
			allEntities: state => state.entities.allEntities,
			regions: state => state.regions.regions
		}),

		statusItems() {
			return [
				{ id: debtPaymentStatus.unpaid, name: this.$T('DebtVisits.payment-status.unpaid') },
				{ id: debtPaymentStatus.partiallyPaid, name: this.$T('DebtVisits.payment-status.partially-paid') },
				{ id: debtPaymentStatus.paid, name: this.$T('DebtVisits.payment-status.paid') }
			]
		}
	},

	methods: {
		fetchDebtVisits() {
			return this.$store.dispatch('debtVisits/fetchAll', {
				employeeId: this.self.employeeId,
				entityIds: this.entityIds,
				regionIds: this.regionIds,
				paymentStatuses: this.paymentStatuses,
				page: 1,
				perPage: this.perPage
			})
		},

		filter() {
			this.perPage = this.initPerpage
			this.loading = true
			this.fetchDebtVisits().finally(() => {
				this.loading = false
			})
		},

		loadMoreOnScroll() {
			// if scrolled to bottom and number of visits not less then perpage, load more items
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && !(this.visits.length < this.perPage)) {
				this.perPage += this.nextPlusItemsforPerPage
				this.loading = true
				this.fetchDebtVisits().finally(() => {
					this.loading = false
				})
			}
		},

		onPaymentUpdated() {
			this.filter()
			this.$store.dispatch('profile/fetchBalance')
		}
	},

	created() {
		this.loading = true
		Promise.all([
			this.$store.dispatch('entities/fetchAllGroupedByRegion'),
			this.$store.dispatch('regions/fetchAll'),
			this.fetchDebtVisits()
		]).finally(() => {
			this.loading = false
		})

		window.addEventListener('scroll', this.loadMoreOnScroll)
	},

	beforeDestroy() {
		this.$store.dispatch('debtVisits/reset')
		this.$store.dispatch('entities/reset')
		this.$store.dispatch('regions/reset')

		window.removeEventListener('scroll', this.loadMoreOnScroll)
	}
}
</script>
